import { Box, Flex, Grid, GridItem, Image, Text, Drawer, DrawerOverlay, DrawerContent, DrawerCloseButton, DrawerHeader, DrawerBody, FormControl, FormLabel, Button, Center, Spinner, FormErrorMessage, Checkbox, SimpleGrid } from "@chakra-ui/react";
import MyDiv from "./employeeCategory.style";
import { useEffect, useState } from "react";
import PlusIcon from "../../../assets/images/Vector.svg"
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { ActionEditIcon, CustomButton, CustomTable, CustomToast } from "../../../components";
import { useFetch } from "../../../hooks/useFetch";
import { Column } from "../../../components/CustomTable/customTable";
import { HrlenseInput } from "../../../components/Input/Input";
import { IIncrementEmployeeCategory, EmployeeCategoryDefaultValues, incrementEmployeeCategorySchema } from "./model";
import { Dropdown } from "../../../components/DropDown/DropDown";
import { ICompanyDropdown } from "../../Admin/Master/Branch/model";
import { IDepartment } from "../../Admin/Master/Department/model";

const EmployeeCategory = () => {
    const [records, setRecords] = useState<IIncrementEmployeeCategory[]>([]);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const { addToast } = CustomToast();
    const { fetchApi, loading } = useFetch(addToast);
    const [companies, setCompanies] = useState<ICompanyDropdown[]>([])
    const [department, setDepartment] = useState<IDepartment[]>([])
    const [generalSetting, setGeneralSetting] = useState<any[]>([])

    const { control, handleSubmit, reset, formState: { errors } } = useForm<IIncrementEmployeeCategory>({
        resolver: yupResolver(incrementEmployeeCategorySchema) as any,
        defaultValues: EmployeeCategoryDefaultValues
    });


    const categoryOptions = [
        { label: "Executive", value: "Executive" }
    ];

    useEffect(() => {
        loadRecords();
    }, []);

    const loadRecords = async () => {
        const response = await fetchApi<any[]>("IncrementSettings/EmployeeCategory", "GET");
        if (response) {
            setRecords(response);
        }
    };

    const handleAddNew = () => {
        setIsEditMode(false);
        reset(EmployeeCategoryDefaultValues);
        setDrawerOpen(true);
    };

    const handleEdit = (record: IIncrementEmployeeCategory) => {
        setIsEditMode(true);
        reset(record);
        setDrawerOpen(true);
    };

    const onSubmit = async (data: IIncrementEmployeeCategory) => {

        if (isEditMode) {
            const response = await fetchApi(`IncrementSettings/EmployeeCategory/${data.id}`, "PUT", data, null, "Record updated successfully");
            if (response) {
                loadRecords();
                setDrawerOpen(false);
            }
        } else {
            const response = await fetchApi<any>("IncrementSettings/EmployeeCategory", "POST", data, null, "Record added successfully");
            if (response) {
                loadRecords();
                setDrawerOpen(false);
            }
        }
    };


    const LoadBusinessProcess = async () => {
        const response = await fetchApi("DropDown/businessProcess", "GET")
        if (response) {
            setCompanies(response)
        }
    }
    const LoadDepartment = async () => {
        const response = await fetchApi("DropDown/department", "GET")
        if (response) {
            setDepartment(response)
        }
    }

    const LoadGeneralSetting = async () => {
        const response = await fetchApi("IncrementSettings/GetIncrementCycleDropdown", "GET")
        if (response) {
            setGeneralSetting(response)
        }
    }


    useEffect(() => {
        LoadBusinessProcess();
        LoadDepartment()
        LoadGeneralSetting();
    }, []);


    return (
        <MyDiv>
            <Box position="relative" minH="300px">
                {loading ? (
                    <Center position="absolute" top={0} left={0} right={0} bottom={0}>
                        <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="#006838" size="xl" />
                    </Center>
                ) : (
                    <>
                        <Flex className="page_heading flex_header">
                            <Text className="font-poppins text_semibold text_3xl">Employee Category</Text>
                            <Flex gap={2}>
                                <CustomButton title="Add New Employee Category" className=" btn font-poppins text_sm text_medium" onClick={handleAddNew} />
                            </Flex>
                        </Flex>
                        <Grid className="grid_container">
                            <GridItem colSpan={12}>
                                <CustomTable value={records} emptyMessage="No Records Found">
                                    <Column<any> header="S. No" body={(_, index) => index + 1} />
                                    <Column<any> field="business_Process_Name" header="Business Process" />
                                    <Column<any> field="department_Name" header="Department" />
                                    <Column<any> field="usePerformanceEvaluation" header="Performance" body={(row) => (row.usePerformanceEvaluation ? "Yes" : "No")} />
                                    <Column<any> field="useEffortModule" header="Effort" body={(row) => (row.useEffortModule ? "Yes" : "No")} />
                                    <Column<any> field="useDisciplineModule" header="Discipline" body={(row) => (row.useDisciplineModule ? "Yes" : "No")} />
                                    {/* <Column<any> field="useTeamMetrics" header="Team Metrics" body={(row) => (row.useTeamMetrics ? "Yes" : "No")} /> */}
                                    {/* <Column<any> field="isActive" header="Status" body={(row) => row.isActive ? (
                                        <span style={{ color: "green", fontWeight: 500 }}>Active</span>
                                    ) : (
                                        <span style={{ color: "red", fontWeight: 500 }}>Inactive</span>
                                    )
                                    }
                                    /> */}
                                    <Column<any> header="Action" body={(rec) => (<ActionEditIcon onClick={() => handleEdit(rec)} />)} />
                                </CustomTable>
                            </GridItem>
                        </Grid>
                        <Drawer isOpen={drawerOpen} placement="right" onClose={() => setDrawerOpen(false)} size="md">
                            <DrawerOverlay />
                            <DrawerContent>
                                <DrawerCloseButton />
                                <DrawerHeader borderBottomWidth="1px">
                                    {isEditMode ? "Edit Employee Category" : "Add New Employee Category "}
                                </DrawerHeader>
                                <DrawerBody >
                                    <form onSubmit={handleSubmit(onSubmit)}>
                                        <Box mt={2}>
                                            <Dropdown isRequired label="Business Process" placeholder="Select Business Process" options={companies} control={control} errors={errors} name="businessProcess" labelKey="business_Process_Name" valueKey="business_Process_Id" />
                                        </Box>
                                        <Box mt={2}>
                                            <Dropdown isRequired label="Department" placeholder="Select Department" options={department} control={control} errors={errors} name="department_Id" labelKey="departmentName" valueKey="id" />
                                        </Box>
                                        <Box mt={2}>
                                            <Dropdown isRequired label="Category" placeholder="Select Category" options={categoryOptions} control={control} errors={errors} name="category" labelKey="label" valueKey="value" />
                                        </Box>
                                        <Box mt={2}>
                                            <Dropdown isRequired label="Default Cycle Year" placeholder="Select Default Cycle Year" options={generalSetting} control={control} errors={errors} name="general_Setting_Id" labelKey="year" valueKey="id" />
                                        </Box>


                                        <Text className="font-poppins text_md text_medium" mt={2}>Performance</Text>
                                        <SimpleGrid columns={2} spacing={4} mt={2}>

                                            <Controller
                                                name="usePerformanceEvaluation"
                                                control={control}
                                                render={({ field: { value, onChange } }) => (
                                                    <Checkbox isChecked={value} onChange={onChange} colorScheme="green">
                                                        Use Performance Evaluation
                                                    </Checkbox>
                                                )}
                                            />
                                            <Controller
                                                name="useEffortModule"
                                                control={control}
                                                render={({ field: { value, onChange } }) => (
                                                    <Checkbox isChecked={value} onChange={onChange} colorScheme="green">
                                                        Use Effort Module
                                                    </Checkbox>
                                                )}
                                            />
                                            <Controller
                                                name="useDisciplineModule"
                                                control={control}
                                                render={({ field: { value, onChange } }) => (
                                                    <Checkbox isChecked={value} onChange={onChange} colorScheme="green">
                                                        Use Discipline Module
                                                    </Checkbox>
                                                )}
                                            />
                                            {/* <Controller
                                                name="useTeamMetrics"
                                                control={control}
                                                render={({ field: { value, onChange } }) => (
                                                    <Checkbox isChecked={value} onChange={onChange} colorScheme="green">
                                                        Use Team Metrics
                                                    </Checkbox>
                                                )}
                                            /> */}
                                        </SimpleGrid>
                                        <Flex position="fixed" bottom={5} right={5} gap={2}>
                                            <Button className="font-poppins text_sm text_medium" onClick={() => setDrawerOpen(false)} > Cancel </Button>
                                            <Button type="submit" isLoading={loading} className="btn_theme" > {isEditMode ? "Update Category" : "Add Category"} </Button>
                                        </Flex>
                                    </form>
                                </DrawerBody>
                            </DrawerContent>
                        </Drawer>
                    </>
                )}
            </Box>
        </MyDiv>
    );
};

export default EmployeeCategory;